import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatCardModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatSortModule, MatTableModule } from '@angular/material';
import { VerticalLayout1Module } from 'app/layout/vertical/layout-1/layout-1.module';
import { ApplicationPipesModule } from 'app/main/application-pipes/application-pipes.module';
import { SharedModule } from 'app/main/shared/shared.module';



@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonModule,
        SharedModule,
        VerticalLayout1Module,
        MatCardModule,
        ApplicationPipesModule,
        MatProgressBarModule,
        MatProgressSpinnerModule
    ],
    exports: [
        VerticalLayout1Module,
    ],
    declarations: [

    ]
})
export class LayoutModule {
}
